export enum ProxyWorkflowStatusType {
  Pending = 1,
  InReview = 2,
  NeedsInfo = 3,
  Approved = 4,
  Denied = 5,
}
